type Row = Record<string, unknown>;

/** `…/event/detail/{hex}` の hex を返す（J.P ROOM 告知ページの実体キー） */
export function jpRoomEventDetailHash(detailUrl: unknown): string | null {
  const m = String(detailUrl ?? "").match(/\/event\/detail\/([a-f0-9]+)/i);
  return m ? m[1]!.toLowerCase() : null;
}

/** 同一告知・同一公演とみなして管理一覧を1行にまとめるキー（会場・開演枠まで含め、同日複数公演は潰さない） */
export function jpRoomAdminDedupeKey(r: Row): string | null {
  if (String(r.source ?? "") !== "jp_room") return null;
  const h = jpRoomEventDetailHash(r.detail_url);
  if (!h) return null;
  const date = String(r.event_date ?? "").trim();
  const door = String(r.door_time ?? "").trim();
  const cur = String(r.curtain_time ?? "").trim();
  const venue = String(r.venue ?? "").trim();
  return `${h}|${date}|${door}|${cur}|${venue}`;
}

function pickPreferredJpRoomRow(a: Row, b: Row): Row {
  const ak = Number(a.is_karin) - Number(b.is_karin);
  if (ak !== 0) return ak > 0 ? a : b;
  const av = String(a.visibility) === "public" ? 1 : 0;
  const bv = String(b.visibility) === "public" ? 1 : 0;
  if (av !== bv) return av > bv ? a : b;
  const ida = String(a.id);
  const idb = String(b.id);
  if (ida.length !== idb.length) return ida.length <= idb.length ? a : b;
  return ida < idb ? a : b;
}

/**
 * 「M-line J.P ROOM 予定管理」で、同一告知 URL の共有イベントがメンバー人数ぶん並ぶのを避け、1行に畳む。
 * DB・同期ロジックは変えず、表示と一括公開の対象行だけを減らす。
 */
export function dedupeJpRoomRowsForAdminList(rows: Row[], mode: string | undefined): Row[] {
  if (mode !== "jp_room") return rows;

  const winnerByKey = new Map<string, Row>();
  for (const r of rows) {
    const key = jpRoomAdminDedupeKey(r);
    if (!key) continue;
    const prev = winnerByKey.get(key);
    winnerByKey.set(key, prev ? pickPreferredJpRoomRow(prev, r) : r);
  }

  const emitted = new Set<string>();
  const out: Row[] = [];
  for (const r of rows) {
    const key = jpRoomAdminDedupeKey(r);
    if (!key) {
      out.push(r);
      continue;
    }
    const w = winnerByKey.get(key);
    if (!w || r !== w) continue;
    if (emitted.has(key)) continue;
    emitted.add(key);
    out.push(r);
  }
  return out;
}
